import Img2 from "../../assets/icons/FooterBackground.png";
import styled from "styled-components";
import fipayFonts from "../../theme/index";

export const NewsLetterContainer = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  align-items: center;
  background-image: url("/assets/icons/FooterBackground.png");
  background-size: cover;
  padding-top: 80px;
  padding-bottom: 40px;
`;

export const NewsLetterBox = styled.div`
  padding: 0 20%;
  margin: 1rem;

  @media screen and (min-width: 0px) and (max-width: 766px) {
    width: 80%;
    padding: 0px;
  }

  @media screen and (min-width: 767px) and (max-width: 1024px) {
    width: 100%;
    padding: 0px;
    margin: 20px;
  }
`;

export const NewsLetterButton = styled.button`
  background-color: #ffffff33;
  color: #ffffff;
  border-radius: 30px;
  padding: 0 4rem;
  margin-top: 10px;
  border: 0px;
  outline: none;
  color: white;

  @media screen and (max-width: 700px) {
    font-family: GT Walsheim Pro;
    font-size: ${fipayFonts.fipayFonts.fontSize.footer1};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    line-height: ${fipayFonts.fipayFonts.lineHeight.footer1};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    text-align: center;
  }
`;

export const NewsLetterUpdate = styled.div`
  h2 {
    font-family: "GT Walsheim Pro";
    font-size: 2.8rem;
    font-weight: bold;
    letter-spacing: 0.5px;
    color: #ffffff;

    @media screen and (max-width: 700px) {
      font-family: GT Walsheim Pro;
      font-size: ${fipayFonts.fipayFonts.fontSize.heading3};
      font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
      line-height: ${fipayFonts.fipayFonts.lineHeight.heading3};
      letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.heading};
      text-align: center;
    }
  }
`;

export const NewsLetterLorem = styled.div`
  font-family: GT Walsheim Pro;

  font-size: ${fipayFonts.fipayFonts.fontSize.body2};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  line-height: ${fipayFonts.fipayFonts.lineHeight.body3};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  text-align: center;
  color: #ffffff;

  @media screen and (max-width: 700px) {
    font-family: GT Walsheim Pro;
    font-size: ${fipayFonts.fipayFonts.fontSize.body3};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body2};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
    text-align: center;
  }
`;

export const NewsLetterInput = styled.form`
  padding: 10px 25px;
  height: 45px;
  width: 30%;
  margin: 3rem;
  border-radius: 50px;
  background-color: white;
  display: flex;
  justify-content: space-between;
  align-item: center;
  gap: 1rem;

  @media screen and (max-width: 700px) {
    padding: 10px 12px;
    width: 80%;
  }

  @media screen and (min-width: 767px) and (max-width: 1025px) {
    width: 50%;
  }
`;

export const InputField = styled.input`
  flex: 1;
  outline: none;
  border: none;
  width: 50%;
  background-color: transparent;

  @media screen and (max-width: 700px) {
    padding: 20px;
  }
`;

export const SubmitButton = styled.button`
  border: 1px solid green;
  border: none;
  width: 155px;
  border-radius: 30px;
  background-color: #00c703;
  color: white;
  font-size: 1rem;
  font-weight: bold;
  letter-spacing: 0.5px;

  @media screen and (max-width: 700px) {
    padding: 10px 12px;
    width: 40%;
  }
  &:hover {
    background-color: #80e381;
  }
`;

export const NotificationContainer = styled.div`
  position: fixed;
  top: 40px;
  left: 880px;
  width: 460px;
  height: 62px;
  padding: 4px;
  border-radius: 10px;
  background-color: white;
  color: black;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 768px) {
    position: fixed;
    top: 40px;
    left: 50%;
    transform: translateX(-50%);
    width: 460px;
    height: 62px;
  }

  @media (max-width: 480px) {
    top: 10px;
    width: 50%;
    max-width: 100%;
    padding: 5px;
    font-size: 14px;
  }
`;

export const NotificationText = styled.p`
  margin: 0;
  font-family: GT Walsheim Pro;
  font-size: ${fipayFonts.fipayFonts.fontSize.body2};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  line-height: ${fipayFonts.fipayFonts.lineHeight.body3};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  @media (max-width: 480px) {
    font-size: 14px;
  }
`;
